export const isPostOffice = (pointType?: unknown): pointType is 'post_office' => pointType === 'post_office'
